import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const validators = [
    (value, data) =>
        data.shareAccessEnabled || Object.values(data.contactPerson || {}).some((val) => !!val)
            ? requiredField(value)
            : "",
];

const config = {
    name: {
        label: "Название",
        validators,
        required: true,
        inputProps: { name: "name" },
    },
    inn: {
        label: "ИНН",
        validators,
        required: true,
        inputProps: { name: "inn" },
    },
    kpp: {
        label: "КПП",
        inputProps: { name: "kpp" },
    },
    contactPerson: {
        config: {
            firstName: {
                label: "Имя контактного лица",
                validators,
                required: true,
                inputProps: { name: "firstName" },
            },
            lastName: {
                label: "Фамилия контактного лица",
                validators,
                required: true,
                inputProps: { name: "lastName" },
            },
            patronymic: {
                label: "Отчество контактного лица",
                inputProps: { name: "patronymic" },
            },
            phoneNumber: {
                label: "Телефон контактного лица",
                validators,
                required: true,
                type: "phone",
                inputProps: { name: "phoneNumber" },
            },
            email: {
                label: "Email для приглашения",
                validators,
                required: true,
                inputProps: { name: "email", type: "email" },
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
